var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcastsQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "podcasts_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M16.4,14a2.361,2.361,0,0,1-1.2,2.064V26H12.8V16.064A2.376,2.376,0,0,1,11.6,14a2.4,2.4,0,0,1,4.8,0ZM14,6.8A7.185,7.185,0,0,0,9.128,19.28l1.7-1.7A4.748,4.748,0,0,1,9.2,14a4.8,4.8,0,1,1,9.6,0,4.748,4.748,0,0,1-1.632,3.576l1.7,1.7A7.185,7.185,0,0,0,14,6.8ZM14,2A11.994,11.994,0,0,0,5.732,22.688l1.7-1.7a9.6,9.6,0,1,1,13.128,0l1.7,1.7A11.994,11.994,0,0,0,14,2Z",
    transform: "translate(-2 -2)",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastsQuality);
export default __webpack_public_path__ + "static/media/podcastsQuality.b5c896c566cc21a14710cac3af386a7c.svg";
export { ForwardRef as ReactComponent };